export default __webpack_public_path__ + "static/media/nose.12895960.svg";